import React, { useState } from "react";
import LogoLight from "../../asset/logo_light.png";
import "./LoginAndSignup.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons/faCircleXmark";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const translations = {
  english: {
    recovery: "Send recovery email",
    forgetPassword: "Have you forgotten your password?",
    loginError: "Login failed",
    notRegistered: "Not Registered? Go to signup page",
    password: "Password",
    email: "Email Address",
    login: "Login",
    alreadyRegistered: "Go to login page",
  },
  german: {
    recovery: "Passwort zurücksetzen",
    forgetPassword: "Haben Sie Ihr Passwort vergessen?",
    loginError: "Login ist fehlgeschlagen",
    notRegistered: "Nicht registriert? Zur Anmeldeseite gehen",
    password: "Passwort",
    email: "E-Mail Adresse",
    login: "Login",
    alreadyRegistered: "Bereits registriert? Gehen Sie zur Login-Seite.",
  },
  italian: {
    recovery: "Send recovery email",
    forgetPassword: "Hai dimenticato la password?",
    loginError: "Accesso non riuscito",
    notRegistered: "Non sei registrato? Vai alla pagina di registrazione",
    password: "Password",
    email: "Indirizzo Email",
    login: "Accedi",
    alreadyRegistered: "Già registrato? Vai alla pagina di accesso.",
  },
  czech: {
    recovery: "Send recovery email",
    forgetPassword: "Zapomněli jste heslo?",
    loginError: "Přihlášení se nezdařilo",
    notRegistered: "Nejste registrováni? Přejděte na registrační stránku",
    password: "Heslo",
    email: "Emailová Adresa",
    login: "Přihlásit se",
    alreadyRegistered: "Již registrováni? Přejděte na přihlašovací stránku.",
  },
};
const config = require("../../config.js");
function RecoveryPasswordPage() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [currentLanguage] = useState(
    localStorage.getItem("language") || "english"
  );
  const lang = translations[currentLanguage];

  const clearInput2 = () => setEmail("");

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const response = await axios.post(
        config.env.API_BASE_URL + "/api/auth/reset-password",
        {
          email,
        }
      );

      alert("Reset password sent. Follow the instructions in the email");
      navigate("/");
    } catch (error) {
      console.log(error);
      setError(error.response ? error.response.data.message : lang.loginError);
    }
  };

  const GotoSignupPage = () => {
    navigate("/signup");
  };

  return (
    <div className="loginandsignup-main">
      <div className="d-flex justify-content-center align-items-center flex-column gap-4">
        <img src={LogoLight} alt="logo" width={300} />
        <section className="loginandsignup">
          <form onSubmit={handleSubmit}>
            {error && <p className="error-message">{error}</p>}
            <div className={`input-wrap ${email ? "has-value" : ""}`}>
              <input
                type="email"
                className="login-input2"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <label>{lang.email}</label>
              {email && (
                <button
                  type="button"
                  className="clear-button"
                  onClick={clearInput2}
                >
                  <FontAwesomeIcon
                    className="input-close-icon"
                    icon={faCircleXmark}
                  />
                </button>
              )}
            </div>
            <div className="d-flex justify-content-center">
              <button type="submit" className="btn-signup">
                {lang.recovery}
              </button>
            </div>
            <p
              className="fw-light"
              style={{ cursor: "pointer" }}
              onClick={GotoSignupPage}
            >
              {lang.alreadyRegistered}
            </p>
          </form>
        </section>
      </div>
    </div>
  );
}

export default RecoveryPasswordPage;
